// extracted by mini-css-extract-plugin
export default {"block":"GetMoney_block__ixwqq","content":"GetMoney_content__qHQ2p","control":"GetMoney_control__Z0wrn","image":"GetMoney_image__yuty7"};